import axios from 'axios';
import { ElMessage } from 'element-plus'; // 使用Element Plus的消息提示
const languageType = localStorage.getItem('languageType') || 1;
// 创建axios实例
const service = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_API || 'https://wz.20251127.com'}/admin-api`, // 基础URL，可以从环境变量获取，并添加admin-api路径
  timeout: 15000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么，比如添加token
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 为所有请求添加languageType参数
    if (config.method.toLowerCase() === 'get') {
      // GET请求将languageType添加到params中
      config.params = {
        ...config.params,
        languageType
      };
    } else if (config.method.toLowerCase() === 'post' || config.method.toLowerCase() === 'put' || config.method.toLowerCase() === 'patch') {
      // POST/PUT/PATCH请求将languageType添加到data中
      if (config.data) {
        config.data = {
          ...config.data,
          languageType
        };
      } else {
        config.data = { languageType  };
      }
    }
    
    // 可以在这里添加loading效果
    // const loading = Loading.service({ lock: true, text: 'Loading...', spinner: 'el-icon-loading' });
    // config.loading = loading;

    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error);
    // if (error.config.loading) {
    //   error.config.loading.close();
    // }
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data;
    
    // 这里可以根据实际后端返回的数据结构进行调整
    // 例如，如果后端统一返回 { code: 0, data: {}, message: '' }
    // 可以在这里统一处理
    
    // if (response.config.loading) {
    //   response.config.loading.close();
    // }

    return res;
  },
    // 响应拦截器错误处理部分修改
    error => {
      // 对响应错误做点什么
      console.error('响应错误:', error);

      // if (error.config.loading) {
      //   error.config.loading.close();
      // }

      let errorMessage = '请求失败';

      if (error.response) {
        // 服务器返回了错误状态码
        const { status, data } = error.response;

        // 现在使用 data 变量
        console.log('错误响应数据:', data); // 使用 data 变量

        switch (status) {
          case 400:
            errorMessage = data?.message || '请求参数错误'; // 使用 data 中的错误信息
            break;
          case 401:
            errorMessage = '未授权，请重新登录';
            localStorage.removeItem('access_token');
            // 可以跳转到登录页
            // router.push('/login');
            break;
          case 403:
            errorMessage = data?.message || '拒绝访问'; // 使用 data 中的错误信息
            break;
          case 404:
            errorMessage = '请求资源不存在';
            break;
          case 500:
            errorMessage = data?.message || '服务器内部错误'; // 使用 data 中的错误信息
            break;
          default:
            errorMessage = data?.message || `连接错误${status}`; // 使用 data 中的错误信息
        }
      } else if (error.request) {
        // 请求已发出但没有收到响应
        errorMessage = '网络错误，请检查网络连接';
      } else {
        // 其他错误
        errorMessage = error.message || '未知错误';
      }

      // 显示错误消息
      ElMessage.error(errorMessage);

      return Promise.reject(error);
    }

);

export default service;